import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { DocumentHistorique, DocumentHistoriqueAction, DocumentHistoriqueType } from "src/app/core/models/document-historique";
import { ReceptionService } from "src/app/core/services/reception.service";

const ACTIONS: Record<DocumentHistoriqueAction, { label: string; badge: string }> = {
	creation: { label: "Création", badge: "bg-dark-subtle text-body" },
	modification: { label: "Modification", badge: "bg-warning-subtle text-warning" },
	validation: { label: "Validation", badge: "bg-primary-subtle text-primary" },
	annulation: { label: "Annulation", badge: "bg-danger-subtle text-danger" },
	export: { label: "Export", badge: "bg-success-subtle text-success" },
	reexport: { label: "Ré-export", badge: "bg-success-subtle text-success" },
	solde: { label: "Solde", badge: "bg-info-subtle text-info" },
	desolde: { label: "Solde levé", badge: "bg-info-subtle text-info" },
};

const CHAMPS: Record<string, string> = {
	qte: "Quantité reçue",
	prix: "Prix de réception",
	commentaire: "Commentaire",
	depot: "Dépôt",
	statut: "Statut",
	statutReception: "Statut de réception",
	numeroBLFournisseur: "N° BL fournisseur",
	dateBLFournisseur: "Date BL fournisseur",
	dateReception: "Date de réception",
};

/**
 * Historique des modifications d'un document (BC, BL, facture fournisseur).
 * Recharge quand `documentId` ou `version` change : le parent incrémente `version` après une action.
 */
@Component({
	selector: "app-document-historique",
	templateUrl: "./document-historique.component.html",
})
export class DocumentHistoriqueComponent implements OnChanges {
	@Input() documentType: DocumentHistoriqueType;
	@Input() documentId: number;
	@Input() version = 0;

	protected entrees: DocumentHistorique[] = [];
	protected isLoading = false;

	constructor(private receptionService: ReceptionService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.documentType && this.documentId) this.charger();
	}

	private charger(): void {
		this.isLoading = true;
		this.receptionService.getHistorique(this.documentType, this.documentId).subscribe({
			next: (response) => {
				this.entrees = response.data || [];
				this.isLoading = false;
			},
			error: () => {
				this.entrees = [];
				this.isLoading = false;
			},
		});
	}

	protected action(entree: DocumentHistorique) {
		return ACTIONS[entree.action] || { label: entree.action, badge: "bg-secondary-subtle text-secondary" };
	}

	protected champ(entree: DocumentHistorique): string {
		return entree.champ ? CHAMPS[entree.champ] || entree.champ : "";
	}

	protected valeur(entree: DocumentHistorique, valeur: string | null): string {
		if (valeur === null || valeur === undefined || valeur === "") return "—";
		if (entree.champ === "dateReception" || entree.champ === "dateBLFournisseur") {
			const date = new Date(valeur);
			if (!isNaN(date.getTime())) return date.toLocaleDateString("fr-FR");
		}
		return valeur;
	}
}
